// extracted by mini-css-extract-plugin
module.exports = {"section":"Page_section__IRv_p","title":"Page_title__0gtqH","text":"Page_text__qD_Td"};